var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        "text-align": "center",
        padding: "100px 20px",
        "font-family": "Arial,sans-serif",
      },
    },
    [
      _vm.error.statusCode === 404
        ? _c("h1", { staticStyle: { "font-size": "72px", color: "#ccc" } }, [
            _vm._v("404"),
          ])
        : _c("h1", { staticStyle: { "font-size": "48px", color: "#e4393c" } }, [
            _vm._v("Error"),
          ]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticStyle: {
            "font-size": "18px",
            color: "#666",
            "margin-top": "20px",
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.error.statusCode === 404
                  ? "Page not found"
                  : "Something went wrong"
              ) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticStyle: {
            display: "inline-block",
            "margin-top": "30px",
            padding: "10px 30px",
            background: "#13AF87",
            color: "#fff",
            "text-decoration": "none",
            "border-radius": "4px",
          },
          attrs: { href: "/" },
        },
        [_vm._v("\n    Back to Home\n  ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }